
<template> 
    <CardRh :processando="processando" titulo="Etapa 5/5 - Confirmação"  v-if="ativo">  
        <div class="row g-6 g-xl-12"   >
            <div class="row">   
                <div class="col-12 col-sm-6 col-md-6  " >
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full   border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-graduation-cap fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-6 fw-bolder span-texto-info" > Disciplina ({{formData.turma?.turma.descricao}})</span>
                            <span class="fs-8 span-texto-info">{{formData.aula?.descricao}} </span> 
                        </span> 
                    </button> 
                </div>  
                <!-- <div class="col-12 col-sm-6 col-md-6  text-center" v-for="item in formData.disciplinas" :key="item.disciplinaId">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full  border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-comment fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-6 fw-bolder span-texto-info"> Disciplina ({{item.turma_nome}}) </span>
                            <span class="fs-8 span-texto-info">{{item.disciplina_nome}}</span>
                        </span> 
                    </button> 
                </div>   -->
                <div class="col-12 col-sm-6 col-md-6  text-center">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full order border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-comment fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-4 fw-bolder"> Assunto  </span>
                            <span class="fs-7">{{formData.assunto}}</span>
                        </span> 
                    </button> 
                </div>  
                <!-- <div class="col-12 col-sm-6 col-md-6  text-center" v-for="item in formData.instrutorArray" :key="item.id">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full  border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-user-tie fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-6 fw-bolder span-texto-info"> Instrutor </span>
                            <span class="fs-8 span-texto-info">{{item.usuario.nome}}</span>
                        </span> 
                    </button> 
                </div> 
                <div class="col-12 col-sm-6 col-md-6  text-center" v-for="item in formData.auxiliar" :key="item.id">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full  border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-user-tie fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-6 fw-bolder span-texto-info"> Auxiliar </span>
                            <span class="fs-8 span-texto-info">{{item.usuario.nome}}</span>
                        </span> 
                    </button> 
                </div> -->
                <div class="col-12 col-sm-6 col-md-6  text-center">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full me-5 border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-hashtag fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-4 fw-bolder">  Aula de Nº  </span>
                            <span class="fs-7">{{formData.numero}}</span>
                        </span> 
                    </button> 
                </div>  
                <div class="col-12 col-sm-6 col-md-6  text-center">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full me-5 border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-calendar fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-4 fw-bolder">  Data  </span>
                            <span class="fs-7">{{ formatData( formData.data )}}</span>
                        </span> 
                    </button> 
                </div>  
                <div class="col-12 col-sm-6 col-md-6  text-center">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full me-5 border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-clock fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-4 fw-bolder">  Início  </span>
                            <span class="fs-7">{{formData.inicio}}</span>
                        </span> 
                    </button> 
                </div>  
                <div class="col-12 col-sm-6 col-md-6  text-center">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full me-5 border border-success  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-clock fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-4 fw-bolder">  Fim  </span>
                            <span class="fs-7">{{formData.fim}}</span>
                        </span> 
                    </button> 
                </div>  
                <div class="col-12 col-sm-6 col-md-6  text-center" v-for="item in formData.faltas" :key="item.matriculaId">
                    <button  class="btn btn-info-dados btn-flex btn-secondary px-6  position-relative btn-flex-full  border border-danger  border-dashed"> 
                        <span class="menu-icon">
                            <i class="fas fa-user-slash text-danger fa-2x bi fs-2x"></i> 
                        </span>
                        <span class="d-flex flex-column align-items-start ms-2">
                            <span class="fs-6 fw-bolder span-texto-info"> Falta </span>
                            <span class="fs-8 span-texto-info">{{item.aluno}}</span>
                        </span> 
                    </button> 
                </div> 
            </div>
        </div>  
        <br>
        <div>
            <button class="btn btn-warning  float-left  " @click="prevPage( )">
                <i class=" fa fa-angle-left "></i> <span v-html="'&nbsp'"></span> Voltar
            </button>
            <button class="btn btn-success  float-right" @click="complete( )">
                Finalizar <span v-html="'&nbsp'"></span> <i class=" fa fa-angle-right "></i>
            </button>
        </div> 
    </CardRh>   
</template>

<script lang="ts"> 
 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue  } from "vue-class-component";  
    import {  Prop } from 'vue-property-decorator';   
    import Multiselect from '@vueform/multiselect'
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    
    @Options({
        name: "ControladorEtapa5",
        components: {  CardRh , Multiselect },   
    }) 
    export default class ControladorEtapa5 extends Vue {
         
        public processando = false;  
        public ativo = false;  

        @Prop( ) readonly service!: any 
        @Prop( ) readonly turmas_que_controlo!: any 
        @Prop( ) readonly formData!: any 
           
        activated(){ 
            if (!this.formData.instrutorId || !this.formData.assunto ||!this.formData.numero  ) {  
                this.prevPage( );
            }
            this.ativo = true;
        }
        
        deactivated(){
            this.ativo = false;
        }
        
        formatData( data ){
            return SiteUtils.formatData( data );
        }
 
        public complete() {
            this.$emit('complete');
        }

        prevPage() {
            this.$emit('prevPage', {
                pageIndex: 3
            }); 
        } 
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
        padding: 0.55rem 1.25rem;
    } 
    .registro-alteracao{
        text-align: right;
    } 
    .float-left{
        float: left !important;
    } 
    .btn-info-dados{
        width: 100%;
    }
    .float-right{
        float: right;
    } 
    .col-12{
        margin-bottom: 10px;
    } 
    .span-texto-info{
        text-align: left;
    } 
</style> 